import { render, staticRenderFns } from "./DropdownTree.vue?vue&type=template&id=4803d682&"
import script from "./DropdownTree.vue?vue&type=script&lang=ts&"
export * from "./DropdownTree.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports